<template>
<div>
  <!-- bulma menuing -->
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation" >
    <div class="navbar-brand">
      <div style="height:40px" >
        <a id="logo" v-on:click="onLogoClick"  class="navbar-item"><img src="../../assets/images/logo-light.png" id="logo" height="27px" width="77px" ></a>
      </div>

      <a id="burger" v-on:click="toggleBurger()" role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarMainMenu">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarMainMenu" class="navbar-menu">   
      <!-- START -->  
      <div class="navbar-start">        
        <!--<div id="menuSignon" class="navbar-item">
          <router-link to="/members/signon" class="navbar-item"><span style="white-space:pre">Member Sign-In </span><font-awesome-icon :icon="['fas', 'sign-in-alt']" style="color:silver"/>
        </div>-->
        
        <div id="menuLogoff" class="navbar-item has-dropdown is-hoverable is-hidden">
          <span id="menuMember" v-on:click="toggleMenus" class="navbar-link navbar-arrow">Member</span>
          <div class="navbar-dropdown">

            <div id="menuMedicalHistory">
              <router-link id="routerLinkMedicalHistory" to="/members/my-medical-history" class="navbar-item"><span v-on:click="toggleMenus"><!--My Medical History-->{{ $t('menu.mnuMedicalHistory') }}</span></router-link>
            </div>
            <div id="menuMedicalTests">
              <router-link id="routerLinkMedicalTests" to="/members/medical-tests" class="navbar-item"><span v-on:click="toggleMenus"><!--Medical Test Results-->{{ $t('menu.mnuMedicalTests') }}</span></router-link>
            </div>
            <div id="menuOptionalConsents">
              <router-link id="routerLinkOptionalConsents" to="/consent/optional" class="navbar-item"><span v-on:click="toggleMenus"><!--Optional Consents-->{{ $t('menu.mnuOptionalConsents') }}</span></router-link>
            </div>
            <div id="menuAppointments">
              <router-link id="routerLinkAppointments" to="/members/appointments" class="navbar-item"><span v-on:click="toggleMenus"><!--Appointments-->{{ $t('menu.mnuAppointments') }}</span></router-link>
            </div>

            <div id="menuInvite" class="nested dropdown">
              <a class="navbar-item" style="text-align:left"><!--<i class="fas fa-folder-open" style="color:white;margin-right:5px;"></i>-->{{ $t('menu.mnuPhysiciansNetwork') }}</a>
              <div class="dropdown-menu" role="menu">
                <div class="dropdown-content" >
                  <router-link id="routerLinkInvites" to="/members/invite" class="dropdown-item" ><span v-on:click="toggleMenus">{{ $t('menu.mnuInvite') }}</span></router-link>
                  <router-link id="routerLinkSearchForPhysicians" to="/members/my-physicians" class="dropdown-item"><span v-on:click="toggleMenus">{{ $t('menu.mnuMyPhysicians') }}</span></router-link>
                </div>
              </div>
            </div>

            <div id="menuCOVID19Questionnaire">
              <router-link id="routerLinkCOVID19Questionnaire" to="/members/c19-daily-questionnaire" class="navbar-item"><span v-on:click="toggleMenus"><!--COVID-19 Questionnaire-->{{ $t('menu.mnuC19Questionnaire') }}</span></router-link>
            </div>
            <div id="menuQuestionnaire">
              <router-link id="routerLinkDailyQuestionnaire" to="/members/daily-questionnaire" class="navbar-item"><span v-on:click="toggleMenus"><!--Fit for Duty Questionnaire-->{{ $t('menu.mnuDQQuestionnaire') }}</span></router-link>
            </div>    
            <div id="menuDashboard">
              <router-link id="routerLinkDashboard" to="/members/dashboard" class="navbar-item"><span v-on:click="toggleMenus"><!--Fit for Duty Questionnaire-->{{ $t('menu.mnuDashboard') }}</span></router-link>
            </div>     

            <span id="menuLogoffItem" v-on:click="onLogoff()" class="navbar-item"><!--Logoff-->{{ $t('menu.mnuLogoff') }}</span>
          </div>
        </div>

      </div>
        

      <!-- NAVBAR END -->
      <div class="navbar-end">  

        <div class="navbar-item">
          <a href="https://www.linkedin.com/company/ehealthengagement/about/?viewAsMember=true"><font-awesome-icon :icon="['fab', 'linkedin']"  style="color:silver"/></a>
        </div> 
        <div class="navbar-item">
          <a href="https://www.facebook.com/EHealthEngagement/"><font-awesome-icon :icon="['fab', 'facebook']" style="color:silver"/>            </a>
        </div>
        <div style="width:40px"/>
      </div>
    </div>
  </nav>
<div></div>
</div>

</template>

<script>
//import { API } from '../../api/member-api'
const { API } = require( '../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
import messageBox from '../../views/member-app/common/message-box'

export  default {
  name: 'HeaderView',
  methods:
  {
    onLogoClick()
    {
      window.location.href = window.Vue.prototype.$config.api_url + "/eHealthEngagement" ;
      /* switch(API.getPlatform())
      {
        case "dev":
          {
            window.location.href = "http://localhost/eHealthEngagement/";
            return;
          }
        case "test":
          {
            window.location.href = "http://34.196.154.96:82/eHealthEngagement/";
            return;
          }
          case "live":
          {
            window.location.href = "https://www.ehealthengagement.com/eHealthEngagement/";
            return;
          }
      } */
    },
    onLogoff()
    {

      API.logoff(window.sessionKey);
      window.sessionKey = '';

      let menuLogoff = document.getElementById('menuLogoff');
      //let menuSignon = document.getElementById('menuSignon');
      menuLogoff.classList.add('is-hidden');
      //menuSignon.classList.remove('is-hidden'); 
      
      this.$generalMessage(messageBox, this.$t("header.loggedOut"), /*"You have been successfully logged out."*/ this.onLogoffClose);
    },
    onLogoffClose()
    {
      this.$router.push( { path: "/"}); //members/signon"} );
    },
    toggleBurger()
    {
      let burgerIcon = document.getElementById('burger');
      let dropMenu = document.getElementById('navbarMainMenu');
      burgerIcon.classList.toggle('is-active');
      dropMenu.classList.toggle('is-active');      
    },

    toggleMenus()
    {
      //alert('hit');
      //event.target.classList.toggle('is-active')
      let burgerIcon = document.getElementById('burger');
      let dropMenu = document.getElementById('navbarMainMenu');

      burgerIcon.classList.toggle('is-active');
      dropMenu.classList.toggle('is-active');    
    }
  },
  mounted(){
    
    /* let menu = document.getElementById('menuLogoff');
    menu.classList.toggle('is-hidden'); */
    /* var scale = 'scale(1)';
      document.body.style.webkitTransform =  scale;    // Chrome, Opera, Safari
      document.body.style.msTransform =   scale;       // IE 9
      document.body.style.transform = scale;     // General */

    let burger = document.getElementById('burger');
    let menu = document.getElementById('navbarMainMenu');

    const links = menu.querySelectorAll(".navbar-item");
    links.forEach(link => {
        link.addEventListener("click", function () {
            burger.classList.remove("is-active");
            menu.classList.remove("is-active");
        });
    });
  }
}

</script>

<style lang="scss" scoped>

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{  

  // LOGO
  #logo
  {
    background-color:#473F44;
    height:40px;
  }

  // BURGER
  .burger
  {
    height:40px;
    max-height:40px;
    min-height:40px;
    color:silver;
  }

  // NAVBAR
  .navbar
  {
    font-family: Lato;
    font-size: 1em;
    font-weight:300;
    min-height:40px;
    max-height: 40px;
    height:40px;
    margin-bottom: 0px;
    padding-bottom: 0px; 
    background-color:#473F44;
  }

  // BRAND
  .navbar-brand
  { 
    height:400px;
    min-height:40px;
    max-height: 40px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    background-color:#473F44;
  }

  // MENU POSITION
  nav.navbar.is-fixed-top
  {
    margin:0px;
    padding:0px;
    height:40px;
  }

  // MAIN MENU BAR BACK COLOR 
  .navbar-menu
  {
    height:500px;
    background-color:#473F44;
  }

  // MAIN MENU TEXT COLOR 
  .navbar-link
  {
    font-family: Lato;
    font-weight: 300;
    color:white;
  }

  // MAIN MENU MOUSE OVER TEXT COLOR 
  .navbar-link:hover
  {
    color: slategray;
  }

  // MAIN MENU MOUSE OVER TEXT COLOR WHEN THERE IS A DROPDOWN
  .navbar-link:backdrop
  {
    color: black;
  }
  .navbar-link{
    color:white;
    background-color:#473F44 !important;
  }
  .navbar-link:hover{
    color:white;
    background-color:#473F44 !important;
  }
  .navbar-arrow:after {
    border-color:#E3E4E6//cadetblue;
  }

  // SUB MENU BACKGROUND 
  .navbar-dropdown
  {
    font-family: Lato;
    min-width: 130px;
    background-color: rgb(70,130,180);
    color:#F2F3F4;

  }

  // SUB MENU TEXT COLOR
  .navbar-item
  {
    color:#F2F3F4;
    
  }

  // SINGLE SUBMENU MOUSE OVER TEXT
  .navbar-item:hover{
    color:gray;
    background-color: white;
  }  

  // SINGLE SUBMENU MOUSE OVER TEXT
  /* .navbar-item:hover{
    color:white;
    background-color: gray;
  }   */

  .navbar-dropdown:hover {
    color:white;
    //background-color:gray;
  }
  
  // OVERWRITE DEFAULT TO CLOSE MENUS AFTER CLICK
  .navbar-item.is-hoverable:hover .navbar-dropdown 
  {
      display: block !important;
  }
  .navbar-item.is-hoverable:focus-within .navbar-dropdown 
  {
      display: none;
  } 


  // NESTED DROPDOWN MENUS
  .nested.dropdown:hover > .dropdown-menu {
    display: block;
  }
  .nested.dropdown.r .dropdown-menu {
    top: 30px; // MOVE MENU DOWN
    padding-right:0px;
    margin-right:0px;
    width:235px; // SUBMENU WIDTH
    white-space: nowrap;
    margin-left: 10%;
  }
  .nested.dropdown .dropdown-menu {
    top: -12px;
    padding-right:0px;
    margin-right:0px;
    width:100%;
    white-space: nowrap;
    //margin-left: -100%;
  }
  .nested.dropdown .dropdown-trigger button::after {

  }
  .nested.dropdown .dropdown-trigger button {
    padding: 0px 0px;
    border: 0px;
  }
  .dropdown-content{
    min-width:75px;
    background-color:rgb(70,130,180);
    border:1px solid gray;
    color:white;

  }
  .dropdown-item{
    padding-right:15px !important;
    padding-left:15px;
    color:white;
  }

}

//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px) 
{
  // LOGO
  #logo
  {
    background-color:#473F44;
    height:40px;
  }

  .burger
  {
    height:40px;
    max-height:40px;
    min-height:40px;
    color:silver;
  }
  // NAVBAR
  .navbar
  {    
    font-family: Lato;
    font-size: 1em;
    font-weight:300;
    min-height:40px;
    max-height: 40px;
    height:40px;
    margin-bottom: 0px;
    padding-bottom: 0px;    
  }

  // BRAND
  .navbar-brand
  {
    height:40px;
    min-height:40px;
    max-height: 40px;
    margin-bottom: 0px;
    padding-bottom: 0px;
    background-color:#473F44;
  }

  // MENU POSITON
  nav.navbar.is-fixed-top
  {
    margin:0px;
    padding:0px;
    height:40px;
  }

  // MAIN MENU BAR BACK COLOR 
  .navbar-menu
  { 
    height: 40px;
    font-weight: 300;
    background-color:#473F44;
  }
  
  // MAIN MENU TEXT COLOR 
  .navbar-link
  {
    font-family: Lato;
    font-weight: 300;
    color: white ;
  }

  // MAIN MENU MOUSE OVER TEXT COLOR WHEN THERE IS A DROPDOWN
  .navbar-link:backdrop
  {
    color: black;
  }
  .navbar-link{
    color:white;
    background-color:#473F44 !important;
  }
  .navbar-link:hover{
    color:white;
    background-color:#473F44 !important;
  }
  .navbar-arrow:after {
    border-color:#E3E4E6//cadetblue;
  }

  // SUB MENU BACKGROUND 
  .navbar-dropdown
  {
    font-family: Lato;
    font-weight: 300;
    min-width: 130px;
    background-color: rgb(70,130,180);
    color:gray;
    
  }

  // SUB MENU TEXT COLOR
  .navbar-item
  {
    color:white;
    text-align: left;
  }

  // SINGLE SUBMENU MOUSE OVER TEXT
  .navbar-item:hover{
    color:gray;
    background-color: white;
  }  
  .navbar-dropdown:hover {
    color:white;
    //background-color:gray;
    
  }
  
  // OVERWRITE DEFAULT TO CLOSE MENUS AFTER CLICK
  .navbar-item.is-hoverable:hover .navbar-dropdown 
  {
      display: block !important;
  }
  .navbar-item.is-hoverable:focus-within .navbar-dropdown 
  {
      display: none;
  } 

  // NESTED DROPDOWN MENUS
  .nested.dropdown:hover > .dropdown-menu {
    display: block;
  }
  .nested.dropdown.r .dropdown-menu {
    top: -12px;
    padding-right:0px;
    margin-right:0px;
    width:235px; // SUBMENU WIDTH
    white-space: nowrap;
    margin-left: 100%; //100%;
  }
  .nested.dropdown .dropdown-menu {
    top: -12px;
    padding-right:0px;
    margin-right:0px;
    width:100%;
    white-space: nowrap;
    margin-left: 100%; //-100%;
  }
  
   .nested.dropdown .dropdown-trigger button::after {

  }
  .nested.dropdown .dropdown-trigger button {
    padding: 0px 0px;
    border: 0px;
  }
  .dropdown-content{
    min-width:75px;
    background-color:rgb(70,130,180);
    color:white;

  }
  .dropdown-item{
    padding-right:15px !important;
    padding-left:15px;
    color:white;
  }

  ////////////////////////
 
}
   
  
</style>